'use client';

import { c as _c } from "react/compiler-runtime";
import { MapSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { AccommodationStaysMapSheet } from '~/components/TripOverview/accommodationPage/AccommodationStaysMapSheet';
import { TransportLegsMapSheet } from '~/components/TripOverview/transportPage/TransportLegsMapSheet';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { ItineraryTimeline } from './ItineraryTimeline';
import styles from './ItineraryTimeline.module.css';
import type { TripItineraryProps } from './TripItinerary.types';
export const TripItinerary = t0 => {
  const $ = _c(40);
  const {
    groups,
    originLocationName,
    isEditable,
    tripId,
    returnLegId,
    cardSection: t1,
    sectionHeadingKey,
    accommodationStaysByItemId,
    desktopTransparent: t2
  } = t0;
  const cardSection = t1 === undefined ? "overview" : t1;
  const desktopTransparent = t2 === undefined ? false : t2;
  const t = useTranslations("journey");
  const isDesktop = useIsDesktop();
  const [isMapOpen, setIsMapOpen] = useState(false);
  const showSeeOnMapButton = cardSection === "accommodation" || cardSection === "transport";
  let t3;
  if ($[0] !== cardSection || $[1] !== tripId) {
    t3 = cardSection === "accommodation" ? <AccommodationStaysMapSheet tripId={tripId} onClose={() => setIsMapOpen(false)} /> : <TransportLegsMapSheet onClose={() => setIsMapOpen(false)} />;
    $[0] = cardSection;
    $[1] = tripId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const mapSheet = t3;
  const t4 = desktopTransparent && styles.itinerarySectionNoDesktopSpacing;
  let t5;
  if ($[3] !== t4) {
    t5 = clsx(styles.itinerarySection, t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = desktopTransparent && styles.frameNoDesktopBackground;
  let t7;
  if ($[5] !== t6) {
    t7 = clsx(styles.frame, t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== sectionHeadingKey || $[8] !== t) {
    t8 = sectionHeadingKey ? t(sectionHeadingKey) : t("overview_itinerary_drawer_aria_label");
    $[7] = sectionHeadingKey;
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <h3 className={styles.heading} id="itinerary-heading">{t8}</h3>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== cardSection || $[13] !== showSeeOnMapButton || $[14] !== t) {
    t10 = showSeeOnMapButton ? <button type="button" className={styles.seeOnMapButton} data-test-id={`${cardSection}-see-on-map`} onClick={() => setIsMapOpen(true)}><MapSolid decorative={true} size="small" />{t("accommodation_see_on_map")}</button> : null;
    $[12] = cardSection;
    $[13] = showSeeOnMapButton;
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className={styles.headingRow}>{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== accommodationStaysByItemId || $[20] !== cardSection || $[21] !== groups || $[22] !== isEditable || $[23] !== originLocationName || $[24] !== returnLegId || $[25] !== tripId) {
    t12 = <ItineraryTimeline groups={groups} originLocationName={originLocationName} isEditable={isEditable} tripId={tripId} returnLegId={returnLegId} cardSection={cardSection} accommodationStaysByItemId={accommodationStaysByItemId} />;
    $[19] = accommodationStaysByItemId;
    $[20] = cardSection;
    $[21] = groups;
    $[22] = isEditable;
    $[23] = originLocationName;
    $[24] = returnLegId;
    $[25] = tripId;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12 || $[29] !== t7) {
    t13 = <div className={t7}>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t7;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== isDesktop || $[32] !== isMapOpen || $[33] !== mapSheet || $[34] !== showSeeOnMapButton) {
    t14 = showSeeOnMapButton && isMapOpen && !isDesktop ? createPortal(mapSheet, globalThis.document.body) : null;
    $[31] = isDesktop;
    $[32] = isMapOpen;
    $[33] = mapSheet;
    $[34] = showSeeOnMapButton;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t5) {
    t15 = <section className={t5} aria-labelledby="itinerary-heading">{t13}{t14}</section>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t5;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};